import getCampaignParams from '../components/Tracking/getCampaignParams.ts';

const addCampaignParamsToLinks = (selectors: string) => {
  const campaignParams = getCampaignParams();

  const links: NodeListOf<HTMLAnchorElement> = document.querySelectorAll(selectors);

  if (campaignParams?.size > 0 && links?.length > 0) {
    links?.forEach((element) => {
      const deepLink = new URL(element?.href);
      const location: string[] = [
        deepLink.origin,
        deepLink.pathname,
        deepLink.search,
        campaignParams.toString().length > 0 ? (deepLink.search ? '&' : '?') + campaignParams.toString() : '',
        deepLink.hash,
      ];

      element.href = location.join('');
    });
  }
};
export default addCampaignParamsToLinks;
